import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { DecryptionPassword, OwnerWallet, OwnerWalletListResponse } from './types'
import { $params } from "../../../../features/router";

export const ownerWalletListMounted = createEvent()
export const setDecryptionPassword = createEvent<DecryptionPassword>()
export const submitEncodingPassword = createEvent<DecryptionPassword>()

export const getOwnerWalletList = fx<void, OwnerWalletListResponse>({
  method: 'GET',
  url: `/nova/owner-wallet`,
})

export const putEncodingPassword = fx<DecryptionPassword, OwnerWalletListResponse>({
  method: 'PUT',
  url: '/nova/owner-wallet',
})

export const $ownerWallets = restore<OwnerWallet[]>(
  getOwnerWalletList.doneData.map((a) => {
    return a.body
  }),
  [],
)

export const $showPasswordSection = restore(
  getOwnerWalletList.doneData.map((a) => a.body.reduce((showPasswordSection: boolean, item: OwnerWallet )=> {
    return showPasswordSection || !item.isPrivateKeyDecrypted
  },false)),
  false,
)

export const $passwordIncorrect = restore(
  putEncodingPassword.doneData.map((a) => a.body.reduce((showPasswordSection: boolean, item: OwnerWallet )=> {
    return showPasswordSection || !item.isPrivateKeyDecrypted
  },false)),
  false,
)

export const $decryptionPassword = restore(setDecryptionPassword,{
  password: ''
})

sample({
  clock: $ownerWallets,
  source: $ownerWallets,
  fn: (ownerWallets ) => {
    return ownerWallets.reduce((showPasswordSection: boolean, item: OwnerWallet )=> {
      return showPasswordSection || !item.isPrivateKeyDecrypted
    },false);
  },
  target: $showPasswordSection,
})

sample({
  clock: ownerWalletListMounted,
  fn: () => ({}),
  target: getOwnerWalletList,
})

sample({
  clock: submitEncodingPassword,
  source: $params,
  fn: (params, decryptionPassword) => {
    return {
      url: `/nova/owner-wallet/address`,
      body: { ...decryptionPassword },
    }
  },
  target: putEncodingPassword,
})

sample({
  clock: [putEncodingPassword.doneData],
  fn: (doneData) => doneData.body,
  target: [$ownerWallets],
})
